module.exports = __webpack_public_path__ + "static/media/MPU.26a63ed0.svg";